import React, { useState } from "react";
import { Grid, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { red } from "@mui/material/colors";
import Box from "@mui/material/Box";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import CheckCircle from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { API_DOMAIN } from "../../../constants";
import AudioPlayer from "../../AudioPlayer";
//const API_DOMAIN = "https://capacitamos.com/online"

const Grammar = ({ question, selectedAnswer, showCorrect, showInCorrect, setAnswer, courseCode }) => {

  const handleAnswerChange = (event) => {
    if (!showCorrect && !showInCorrect) {
      setAnswer(event.target.value);
    }
  };
  return (
    <Grid container columns={{ xs: 4, md: 12 }}>
      {question ? (
        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-around",
              overflow: "auto",
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <CardContent sx={{ flex: "1 0 auto" }}>
                <Typography component="div" variant="h5">
                  {question.frase}
                </Typography>
              </CardContent>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  pl: 1,
                  pb: 1,
                }}
              >
                <Stack direction="row" spacing={1}>
                  <AudioPlayer
                    audioUrl={`${API_DOMAIN}/contents/cursos/${courseCode}/audios/${question.audio}`}
                    key={question.audio}
                  />
                </Stack>
              </Box>
            </Box>
            <CardMedia
              component="img"
              style={{ maxWidth: 250, height: "auto", margin: "auto" }}
              image={`${API_DOMAIN}/contents/cursos/${courseCode}/img/${question.imagen}`}
              loading="lazy"
            />
          </Box>
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <RadioGroup
                name="quiz"
                value={selectedAnswer}
                onChange={handleAnswerChange}
                row
                style={{ margin: "auto" }}
              >
                {question.options.map((option, index) => (
                  <FormControlLabel
                    key={`${option.id}-${option.respuesta}`}
                    value={`${option.id}-${option.respuesta}`}
                    control={
                      showCorrect && option.respuesta == 1 ? (
                        <CheckCircle color="success" />
                      ) : showInCorrect &&
                        option.respuesta == 0 &&
                        selectedAnswer == `${option.id}-${option.respuesta}` ? (
                        <CancelIcon sx={{ color: red[500] }} />
                      ) : (
                        <Radio />
                      )
                    }
                    label={option.opcion}
                  />
                ))}
              </RadioGroup>
            </Box>
          </Grid>
        </Grid>
      ) : null}
    </Grid>
  );
};

export default Grammar;
